module.exports = __webpack_public_path__ + "static/img/arvores.5609ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arvores.png
// module id = QQRC
// module chunks = 1